__turbopack_context__.v({
  "consentCheckbox": "contact-form-module-scss-module__HVGRwq__consentCheckbox",
  "form": "contact-form-module-scss-module__HVGRwq__form",
  "privacyPolicyLink": "contact-form-module-scss-module__HVGRwq__privacyPolicyLink",
  "submitButton": "contact-form-module-scss-module__HVGRwq__submitButton",
});
